<div class="grid grid-cols-1 md:grid-cols-3 p-16 h-full relative">
  <div
    class="flex flex-col gap-4 items-center px-16 pb-16 overflow-auto relative"
  >
    <div class="text-2xl sticky top-0 w-full py-4 bg-gray-50">
      Nombre des demande d'etude : {{ data.DEEncours }}
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full mt-12">
      <div
        *ngFor="let DE of data.listeDe"
        [class]="
          'bg-' +
          DE.color +
          '-200 border-' +
          DE.color +
          '-500 text-' +
          DE.color +
          '-700'
        "
        class="px-10 py-8 text-xl rounded-md border font-bold flex flex-col"
      >
        <span>{{ DE.Doc_Num }}</span>
        <span class="text-gray-800 text-sm">{{
          DE.Doc_Date | date: "dd/MM/YYYY"
        }}</span>
      </div>
    </div>
    <div>Taux efficacité mensuelle</div>
    <hr />
    <ng-container *ngIf="data && data.DEchartOption">
      <apx-chart
        [series]="data.DEchartOption.series"
        [chart]="data.DEchartOption.chart"
        [dataLabels]="data.DEchartOption.dataLabels"
        [plotOptions]="data.DEchartOption.plotOptions"
        [yaxis]="data.DEchartOption.yaxis"
        [xaxis]="data.DEchartOption.xaxis"
        [legend]="data.DEchartOption.legend"
        [colors]="data.DEchartOption.colors"
        [grid]="data.DEchartOption.grid"
      ></apx-chart>
    </ng-container>
  </div>
  <div
    class="flex flex-col gap-4 items-center border-0 border-l border-r px-16 pb-16 overflow-auto relative"
  >
    <div class="text-2xl sticky top-0 w-full py-4 bg-gray-50">
      Nombre des OF encours
    </div>
    <div class="flex flex-col border-2 w-full">
      <ng-container *ngFor="let _of of data.nbreOf">
        <div class="flex">
          <div class="bg-gray-700 text-white p-10 w-1/2">
            {{ _of.OFParam_Code }}
          </div>
          <div class="p-10">{{ _of.nbre }}</div>
        </div>
        <hr />
      </ng-container>
    </div>

    <ng-container *ngFor="let type of data.listeOF">
      <span>{{ type[0].OFParam_Code }}</span>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <div
          *ngFor="let card of type"
          [class]="
            'bg-' +
            card.color +
            '-200 border-' +
            card.color +
            '-500 text-' +
            card.color +
            '-700'
          "
          class="px-10 py-8 text-xl rounded-md border font-bold flex flex-col"
        >
          {{ card.OF_Num }}
          <span class="text-gray-800 text-sm">{{
            card.OF_Date | date: "dd/MM/YYYY"
          }}</span>
        </div>
      </div>
    </ng-container>

    <div>Taux efficacité mensuelle</div>
    <hr />
    <ng-container *ngIf="data && data.OFchartOption">
      <apx-chart
        [series]="data.OFchartOption.series"
        [chart]="data.OFchartOption.chart"
        [dataLabels]="data.OFchartOption.dataLabels"
        [plotOptions]="data.OFchartOption.plotOptions"
        [yaxis]="data.OFchartOption.yaxis"
        [xaxis]="data.OFchartOption.xaxis"
        [legend]="data.OFchartOption.legend"
        [grid]="data.OFchartOption.grid"
      ></apx-chart>
    </ng-container>
  </div>
  <div
    class="flex flex-col gap-4 items-center px-16 pb-16 overflow-auto relative"
  >
    <div class="text-2xl sticky top-0 w-full py-4 bg-gray-50">
      Nombre des MC encours : {{ data.nbreMC }}
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full">
      <div
        *ngFor="let DE of data.listeMC"
        [class]="
          'bg-' +
          DE.color +
          '-200 border-' +
          DE.color +
          '-500 text-' +
          DE.color +
          '-700'
        "
        class="px-10 py-8 text-xl rounded-md border font-bold flex flex-col"
      >
        <span>{{ DE.Doc_Num }}</span>
        <span class="text-gray-800 text-sm">{{
          DE.Doc_Date | date: "dd/MM/YYYY"
        }}</span>
      </div>
    </div>
    <div>Taux efficacité mensuelle</div>
    <hr />
    <ng-container *ngIf="data && data.MCchartOption">
      <apx-chart
        [series]="data.MCchartOption.series"
        [chart]="data.MCchartOption.chart"
        [dataLabels]="data.MCchartOption.dataLabels"
        [plotOptions]="data.MCchartOption.plotOptions"
        [yaxis]="data.MCchartOption.yaxis"
        [xaxis]="data.MCchartOption.xaxis"
        [legend]="data.MCchartOption.legend"
        [colors]="data.MCchartOption.colors"
        [grid]="data.MCchartOption.grid"
      ></apx-chart>
    </ng-container>
  </div>
</div>
